export default __webpack_public_path__ + "static/media/kohut-2.6d9202c7.jpg";